export default __webpack_public_path__ + "static/media/e_circled.c7a32b40.svg";